import { useEffect } from "react";
import { UserEditModalHeader } from "./UserEditModalHeader";
import { UserEditModalFormWrapper } from "./UserEditModalFormWrapper";

const UserEditModal = ({
  selectedListingId,
  setSelectedListingId,
  listing,
  getListing,
  openGateListModal,
  openTimelineModal,
  setOpenTimelineModal,
  amenities,
}) => {
  useEffect(() => {
    if(!openGateListModal) {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    }
  }
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-750px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <UserEditModalHeader
              setSelectedListingId={setSelectedListingId}
              listing={listing}
              openGateListModal={openGateListModal}
              setOpenTimelineModal={setOpenTimelineModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 px-4 py-2">
              <UserEditModalFormWrapper
                selectedListingId={selectedListingId}
                setSelectedListingId={setSelectedListingId}
                listing={listing}
                getListing={getListing}
                openGateListModal={openGateListModal}
                openTimelineModal={openTimelineModal}
                setOpenTimelineModal={setOpenTimelineModal}
                amenities={amenities}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { UserEditModal };
